export enum SocSubmitStatus {
    Save = 1,
    SaveSubmitFail = 2,
    SaveSubmitPass = 3
}